import React, { useEffect } from "react";
import TourDetails from "../pages/TourDetails";

// Hero Image
import himachalHero from "../assets/shimla.png";

// Gallery Images
import g1 from "../assets/manali.png";
import g2 from "../assets/shimla.png";
import g3 from "../assets/dharamshala.png";
import g4 from "../assets/Manali/Mcleodganj.png";

export default function HimachalTour() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <TourDetails
      title="Himachal Tour Package"
      duration="07 Nights / 08 Days"
      includes="Shimla, Manali, Dharamshala, Mcleodganj"
      heroImage={himachalHero}
      galleryImages={[g1, g2, g3, g4]}
      tourPlan={{
        inclusions: [
          "02 Nights Shimla – Hotel Woodrina or Similar",
          "03 Nights Manali – Manali Heaven or Similar",
          "02 Nights Dharamshala – Triund Heights or Similar",
          "Daily Breakfast & Dinner",
          "Private Cab for Entire Trip",
        ],

        days: [
          {
            title: "Day 01: Chandigarh → Shimla (120 km / 4 hrs)",
            points: [
              "Pickup from Chandigarh Airport / Railway Station",
              "Drive to Shimla",
              "Evening free for leisure",
              "Overnight stay in Shimla",
            ],
          },
          {
            title: "Day 02: Shimla Sightseeing",
            points: [
              "Kufri sightseeing",
              "Mahasu Peak visit",
              "Jakhoo Temple",
              "Mall Road, Ridge, Lakkar Bazaar",
              "Overnight stay in Shimla",
            ],
          },
          {
            title: "Day 03: Shimla → Manali (250 km / 7 hrs)",
            points: [
              "Drive to Manali via Pandoh Dam & Sundernagar Lake",
              "Check-in & rest",
              "Overnight stay in Manali",
            ],
          },
          {
            title: "Day 04: Manali – Solang / Atal Tunnel",
            points: [
              "Visit Solang Valley",
              "Adventure activities: Paragliding, ATV, Zorbing",
              "Visit Atal Tunnel (if open)",
              "Return to hotel & overnight stay",
            ],
          },
          {
            title: "Day 05: Manali – Local Sightseeing",
            points: [
              "Hadimba Temple",
              "Manu Temple",
              "Vashisht Hot Water Springs",
              "Tibetan Monastery",
              "Mall Road visit",
            ],
          },
          {
            title: "Day 06: Manali → Dharamshala (250 km / 7 hrs)",
            points: [
              "Drive to Dharamshala",
              "Evening at leisure",
              "Dinner & overnight stay",
            ],
          },
          {
            title: "Day 07: Dharamshala – Mcleodganj",
            points: [
              "Dalai Lama Temple",
              "Bhagsu Waterfall",
              "Naddi Viewpoint",
              "Tibetan Market",
              "Overnight stay",
            ],
          },
          {
            title: "Day 08: Dharamshala → Chandigarh (250 km)",
            points: [
              "Checkout after breakfast",
              "Drive to Chandigarh",
              "Drop at Airport / Railway Station",
              "Tour Ends with Memories",
            ],
          },
        ],
      }}
    />
  );
}
